import { render, staticRenderFns } from "./CustomHeadersTable.vue?vue&type=template&id=43a1efa3&scoped=true"
import script from "./CustomHeadersTable.vue?vue&type=script&lang=js"
export * from "./CustomHeadersTable.vue?vue&type=script&lang=js"
import style0 from "./CustomHeadersTable.vue?vue&type=style&index=0&id=43a1efa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a1efa3",
  null
  
)

export default component.exports